import { Link } from "react-router-dom";


export function MainHeader() {
  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-14 max-w-screen-2xl items-center justify-between px-3 sm:px-6">
        <div className="flex items-center gap-2 sm:gap-4">
          <Link to="/" className="flex items-center space-x-2">
            <span className="font-bold text-sm sm:text-base">DoDueLife</span>
          </Link>
          <nav className="flex items-center gap-3 sm:gap-6 text-sm font-medium">
            <Link to="/boards" className="transition-colors hover:text-foreground/80">
              Boards
            </Link>
            <Link to="/analytics" className="transition-colors hover:text-foreground/80">
              Analytics
            </Link>
          </nav>
        </div>
        <div className="flex items-center">
          <a
            href="https://doughposit.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:block group relative px-4 py-1.5 text-sm font-medium"
          >
            <span className="relative z-10">Debt-Free Journey → <span className="text-indigo-400 font-semibold transition-all duration-300 group-hover:text-indigo-300">DoughPosit</span></span>
            <div className="absolute inset-0 bg-indigo-500/10 rounded-full scale-x-0 transition-transform duration-300 group-hover:scale-x-100"></div>
          </a>
        </div>
      </div>
    </header>
  );
}